const LoadingSpinner = () => {
    return (
        <i className="fa-duotone fa-spinner-third fa-spin"/>
    )
}

export default LoadingSpinner